// extracted by mini-css-extract-plugin
module.exports = {"container":"AudioPlayer_container__duw1H","containerHidden":"AudioPlayer_containerHidden__lR45m","spinner":"AudioPlayer_spinner__O52Tx"};